import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Badge } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const DetalleCuentaDatosFijos = ({ dataActual }) => {
    if(!dataActual) return null;
    return (
        <div className="bg-light rounded p-3 mb-4 border">
            <Row className="g-3">
                <Col xs={6} md={4} xl={2}>
                    <small className="text-muted d-block fw-bold" style={{ fontSize: '0.75rem' }}>NÚMERO DE CUENTA</small>
                    <span className="fw-medium me-2">{dataActual.numCta}</span>
                    <FontAwesomeIcon icon="copy" className="text-primary" style={{ cursor: 'pointer' }} title="Copiar" onClick={() => navigator.clipboard.writeText(dataActual.numCta)} />
                </Col>
                <Col xs={12} md={4} xl={3}>
                    <small className="text-muted d-block fw-bold" style={{ fontSize: '0.75rem' }}>CLABE</small>
                    <span className="fw-medium me-2">{dataActual.clabe}</span>
                    <FontAwesomeIcon icon="copy" className="text-primary" style={{ cursor: 'pointer' }} title="Copiar" onClick={() => navigator.clipboard.writeText(dataActual.clabe)} />
                </Col>
                <Col xs={6} md={4} xl={3}>
                    <small className="text-muted d-block fw-bold" style={{ fontSize: '0.75rem' }}>CÓDIGO SWIFT</small>
                    <span className="fw-medium me-2">{dataActual.swift}</span>
                    <FontAwesomeIcon icon="copy" className="text-primary" style={{ cursor: 'pointer' }} title="Copiar" onClick={() => navigator.clipboard.writeText(dataActual.swift)} />
                </Col>
                <Col xs={6} md={6} xl={2}>
                    <small className="text-muted d-block fw-bold" style={{ fontSize: '0.75rem' }}>MONEDA</small>
                    <span className="fw-medium">{dataActual.moneda}</span>
                </Col>
                <Col xs={6} md={6} xl={2}>
                    <small className="text-muted d-block fw-bold" style={{ fontSize: '0.75rem' }}>STRIPE</small>
                    {dataActual.stripeActivo ? (
                        <Badge bg="success" text="success" className="bg-opacity-10 text-success">
                            <FontAwesomeIcon icon="check-circle" className="me-1" /> Conectado
                        </Badge>
                    ) : (
                        <Badge bg="secondary" text="secondary" className="bg-opacity-10 text-secondary">No conectado</Badge>
                    )}
                </Col>
            </Row>
        </div>
    );
};

DetalleCuentaDatosFijos.propTypes = {
    dataActual: PropTypes.shape({
        numCta: PropTypes.string,
        clabe: PropTypes.string,
        swift: PropTypes.string,
        moneda: PropTypes.string,
        stripeActivo: PropTypes.bool
    }).isRequired
};
